import React, { useContext } from 'react';
import "./ExamRecommendationRoute.css";
import NavBar from '../../Layouts/NavBar';
import Footer from '../../Layouts/Footer';
// import RoutesBar from './Components/RoutesBar';
import ExamRecommendationForm from './ExamRecommendationForm';
import UserInfoProvider from '../../Context/UserInfoContext';
import MedicalContextProvider from "../../Context/MedicalContext";
import PacksProvider from "../../Context/PacksContext";
import BasketProvider from '../../Context/BasketContext';
import ExamRecommendationBasket from './ExamRecommendationBasket';
import ExamRecommendationPacks from './ExamRecommendationPacks';
//import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
import { Packs } from '../../Context/PacksContext';
import { MedicalContext } from '../../Context/MedicalContext';

function ExamRecommendationRoute() {
    const {
        BasketPacks
    } = useContext(Packs);

    const {
        RelatedExams
    } = useContext(MedicalContext);

    let ExamsForOrder = RelatedExams
    let Basket = JSON.parse(localStorage.getItem("BasketPacks"))

    return (
        <BasketProvider>
        <MedicalContextProvider>
        <PacksProvider>
        <UserInfoProvider>
        <div className="ExamRecommendationRoutePage">
            <div className="ExamRecommendationRouteNavBar">      
                <NavBar/>
            </div>
            {ExamsForOrder.length === 0 & (Basket === null || Basket.length === 0) ?
            <>
            <div className="ExamRecommendationRouteContent">
                <div className="ExamRecommendationRouteTitle">
                    <h1 className='ExamRecommendationRouteTitleText'>Orden Médica</h1>
                </div>
                <div className="ExamRecommendationRouteFormEmpty">
                    <ExamRecommendationForm/>
                </div>
            </div>
            <div className="ExamRecommendationRouteFooter">
                <Footer/>
            </div>
            </>
            :
            <>
            <div className="ExamRecommendationRouteContent">
                <div className="ExamRecommendationRouteTitle">
                    <h1 className='ExamRecommendationRouteTitleText'>Orden Médica</h1>
                </div>
                <div className="ExamRecommendationRouteFlexedParts">
                    <div className="ExamRecommendationRouteLeftSide">
                        <div className="ExamRecommendationRouteForm">
                            <ExamRecommendationForm/>
                        </div>
                    </div>
                    <div className="ExamRecommendationRouteBasket">
                        <ExamRecommendationBasket/>
                    </div>
                </div>
            </div>
            <div className="ExamRecommendationRoutePacks">
                <ExamRecommendationPacks/>
            </div>
            <div className="ExamRecommendationRouteFooter">
                <Footer/>
            </div>
            </>
}
        </div>
       </UserInfoProvider>
       </PacksProvider>
       </MedicalContextProvider>
       </BasketProvider>
    );
}

export default ExamRecommendationRoute;